import { Controller } from "stimulus"
import { track } from "@plausible-analytics/tracker"

export default class extends Controller {
  static values = { event: String, currency: String, amount: Number, props: Object }

  on_purchase() {
    const options = {}
    if (this.hasAmountValue) options.revenue = { currency: "EUR", amount: this.amountValue }
    if (this.hasPropsValue) options.props = this.propsValue

    track(this.eventValue, options)

    // Remove the element to prevent tracking the same event multiple times if the user reloads the page
    this.element.remove()
  }
}
